import type { ChefRecommendation, Testimonial } from '@/data/types';
import { resolveImagePath } from '@/utils/imageMap';
import chefRecommendationsData from '@/data/chefRecommendations.json';
import testimonialsData from '@/data/testimonials.json';

export function ChefRecommendations() {
  const recommendations = chefRecommendationsData as ChefRecommendation[];
  const testimonials = testimonialsData as Testimonial[];

  return (
    <section className="bg-gradient-to-b from-orange-100 to-orange-50 py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Chef's Recommendations Section */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-lg p-6 h-full">
              <h3 
                className="text-2xl font-normal text-amber-900 mb-6 text-center"
                style={{ fontFamily: "'Goudy Bookletter 1911', Georgia, serif" }}
              >
                Chef's Recommendations
              </h3>
              <div className="space-y-6">
                {recommendations.map((item) => (
                  <div key={item.id} className="flex items-start space-x-4 group">
                    <a 
                      href={item.href}
                      className="flex-shrink-0 transition-transform duration-200 group-hover:scale-105"
                    >
                      <img
                        src={resolveImagePath(item.image)}
                        alt={item.title}
                        className="w-14 h-14 object-cover rounded-md shadow-md"
                      />
                    </a>
                    <div className="flex-1 min-w-0">
                      <h4 className="mb-2">
                        <a 
                          href={item.href}
                          className="text-sm font-medium text-amber-900 hover:text-amber-700 transition-colors duration-200"
                          style={{ fontFamily: "'Goudy Bookletter 1911', Georgia, serif" }}
                        >
                          {item.title}
                        </a>
                      </h4>
                      <p className="text-xs text-amber-700 leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Location and Hours Section */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-lg p-6 h-full">
              <h3 
                className="text-2xl font-normal text-amber-900 mb-6 text-center"
                style={{ fontFamily: "'Goudy Bookletter 1911', Georgia, serif" }}
              >
                Location and hours of operation
              </h3>
              <div className="space-y-4">
                <div 
                  id="gmaps-border" 
                  className="border-2 border-amber-200 rounded-lg overflow-hidden mb-4"
                >
                  <div 
                    id="gmaps-container" 
                    className="w-full h-48 bg-amber-50 flex items-center justify-center text-amber-600"
                  >
                    {/* Placeholder for Google Maps */}
                    <span className="text-sm">Google Maps Integration</span>
                  </div>
                </div>
                <div className="space-y-2 text-center">
                  <div className="flex justify-between">
                    <span 
                      className="font-medium text-amber-900"
                      style={{ fontFamily: "'Goudy Bookletter 1911', Georgia, serif" }}
                    >
                      Mon-Fri
                    </span>
                    <span className="text-amber-700">10 am - 9 pm</span>
                  </div>
                  <div className="flex justify-between">
                    <span 
                      className="font-medium text-amber-900"
                      style={{ fontFamily: "'Goudy Bookletter 1911', Georgia, serif" }}
                    >
                      Sat-Sun
                    </span>
                    <span className="text-amber-700">10 am - 9 pm / Closed Sunday</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Customer Testimonials Section */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-lg p-6 h-full">
              <h3 
                className="text-2xl font-normal text-amber-900 mb-6 text-center"
                style={{ fontFamily: "'Goudy Bookletter 1911', Georgia, serif" }}
              >
                Customer Testimonials
              </h3>
              <div className="space-y-4">
                {testimonials.map((testimonial) => (
                  <div key={testimonial.id}>
                    <p 
                      className="text-lg font-medium text-amber-900 text-center mb-4"
                      style={{ fontFamily: "'Goudy Bookletter 1911', Georgia, serif" }}
                    >
                      {testimonial.author}
                    </p>
                    <div className="text-sm text-amber-700 space-y-3 leading-relaxed">
                      {testimonial.content.map((paragraph, index) => (
                        <p key={index}>
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        
        {/* Menu CTA */}
        <div className="text-center mt-12">
          <a 
            href="http://dangsvietnameserestaurant.com/menu/"
            className="inline-block bg-gradient-to-r from-amber-600 to-amber-700 text-white px-8 py-3 rounded-full text-lg font-medium shadow-lg hover:shadow-xl transition-all duration-200 hover:from-amber-700 hover:to-amber-800"
            style={{ fontFamily: "'Goudy Bookletter 1911', Georgia, serif" }}
          >
            Click Here To Browse The Menu
          </a>
        </div>
      </div>
    </section>
  );
}